import Ajax from "./Ajax"
const GetSector = async(locationId, loader) => {
    const response = await Ajax({
        url: `/setting/getSector?limit=false&location=${locationId}`,
        token: true,
        ...(loader && {loader: true})
    })
    return response.data.result
}
export default GetSector